import React from 'react';
import _ from 'lodash';

import { useProductSelectFieldQuery } from 'generated/graphql';



export interface IProduct {
  id: string;
  displayName: string;
}

export interface IData {
  objects: IProduct[];
}

export function useQuery() {
  const queryTuple = useProductSelectFieldQuery({
    variables: {
      options: {}
    }
  });

  const wrappedTuple = React.useMemo(() => {
    const data: IData = {
      objects: _.map(queryTuple.data?.products.nodes ?? [], (node): IProduct => ({
        id: node.id,
        displayName: node.sku
      }))
    };

    return {
      loading: queryTuple.loading,
      data,
      refetch: async () => {
        queryTuple.refetch({});
      }
    };
  }, [queryTuple]);

  return wrappedTuple;
}
